import { X } from 'lucide-react'
import type { FormEvent, ReactNode } from 'react'

export function Toggle({ checked, onChange, label, disabled = false }: { checked: boolean; onChange: (checked: boolean) => void; label: string; disabled?: boolean }) {
  return <label className="toggle-control"><input type="checkbox" checked={checked} disabled={disabled} onChange={(event) => onChange(event.target.checked)} /><span aria-hidden="true"><i /></span>{label && <em>{label}</em>}</label>
}

export function AdminModal({ title, description, onClose, onSubmit, children, submitLabel = '저장' }: { title: string; description: string; onClose: () => void; onSubmit: (event: FormEvent<HTMLFormElement>) => void | Promise<void>; children: ReactNode; submitLabel?: string }) {
  return <div className="modal-backdrop" onMouseDown={onClose}><form className="portal-modal" onSubmit={(event) => void onSubmit(event)} onMouseDown={(event) => event.stopPropagation()}><div className="modal-heading"><div><h2>{title}</h2><p>{description}</p></div><button type="button" onClick={onClose} aria-label="닫기"><X /></button></div>{children}<div className="modal-actions"><button type="button" className="secondary-button" onClick={onClose}>취소</button><button className="primary-button" type="submit">{submitLabel}</button></div></form></div>
}

export function ViewHeading({ label, title, description, action }: { label: string; title: string; description: string; action?: ReactNode }) {
  return <div className="view-heading"><div><span className="eyebrow">{label}</span><h1>{title}</h1><p>{description}</p></div>{action}</div>
}

function csvCell(value: unknown) { return `"${String(value ?? '').replaceAll('"', '""')}"` }

export function downloadCsv(filename: string, headers: string[], rows: unknown[][]) {
  const csv = `\uFEFF${[headers, ...rows].map((row) => row.map(csvCell).join(',')).join('\n')}`
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }))
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.click()
  URL.revokeObjectURL(url)
}
